import { useEffect, useState, useMemo, useRef } from "react"
import selectOnFocus from '../../../../../../modules/autoselect'
import { EXIST_PATH } from '../../../../../../modules/API/settings'
import styled from "styled-components";
import { format } from "date-fns";
import ClickIcon from "../../../../../../generic/icons/IconLib/PointerIcon";
import PackageIcon from "../../../../../../generic/icons/IconLib/PackageBoxIcon";
import ScalesIcon from "../../../../../../generic/icons/IconLib/ScaleIcon";
import { roundToTwo } from "../../../../../../modules/roundToTwo";
import { useSelector } from "react-redux";
import { checkPackType } from "../../../../../../generic/utils/checkPackType";
import { diffDates } from "../../../../../../generic/utils/forDate/diffDates";
import { convertStringDateToUnix } from "../../../../../../generic/utils/forDate/convertStringDateToUnix";
import { handleNotifications } from "../../../../../../generic/utils/handleNotifications";
import ProductCard from '../goods/ProductCard'
import ProductImage from '../../../queries/TeudotDetails/Components/ProductImage'
import { useAvailablePacksWithDefault } from '../hooks/useAvailablePacksWithDefault'

export default function GoodsItemEdit({
    id, ChangeReason, Pallets, SupplyQty, isEditArizot, Price, AllowEdit, PackWeight,
    OrderPacks, ExistingStock, SalePrice, Remarks, RecID, ProductID, VarietyID, getMlai, getMhir,
    setEditGoods, productNonOrder, setProductNonOrder, ProductDesc, VarietyDesc, SizeID,
    ImageUrl, GeneralProductID = 0, PackID, Pack_Name, packegeList, disabelSave, showDetailes, OrderWeight, RecommendQty,
    setDataForDetailes, getGoodPrice, MinPrice, item, Packs, ProductCalculationMethod, AvailablePacks, date, OriginalPrice, isPriced
}) {
    const getRights = useSelector(rights => rights.mainReducer.user.rights);
    const editMhirMlaiStatus = getRights.some(e => e === 'OFFICE' || e === 'SELLER' || e === 'ADMIN');
    const weightRef = useRef(null)
    const orderedPacksRef = useRef(null)
    const [side, setSide] = useState(false)
    const [packs, setPacks] = useState(OrderPacks || +'');
    const [remark, setRemark] = useState(Remarks || '');
    const [packType, setPackType] = useState(PackID || "")
    const [priceGood, setPriceGood] = useState(Price || SalePrice ? roundToTwo(Price || SalePrice) : 0)
    const [mlai, setMlai] = useState(ExistingStock || +'')

    const disableSelectPacks = disabelSave || !isEditArizot || (PackID !== 0 && RecID === 0)
    const isAllowToEditPercanal = AllowEdit === undefined ? true : AllowEdit;
    const isDisableGeneral = !isAllowToEditPercanal || disabelSave
    const dateDiff = diffDates(convertStringDateToUnix(date || format(new Date(), 'yyyyMMdd')), convertStringDateToUnix(format(new Date(), 'yyyyMMdd')))

    const collectData = () => {
        let newArr = [...productNonOrder]
        let found = newArr.find((item) => {
            return item.id === id;
        })
        if (found) {
            let indProd = newArr.indexOf(found)
            newArr.splice((indProd), 1)
        }
        setProductNonOrder([
            ...newArr,
            {
                "id": id,
                "RecID": RecID,
                "ProductID": ProductID,
                "VarietyID": VarietyID,
                "SizeID": SizeID,
                "PackID": +packType,
                "Packs": packs,
                "Mlai": +mlai,
                "Remark": remark,
                "Price": +finalPrice || SalePrice,
                "OrderPacks": packs,
                "ProdName": `${ProductDesc?.trim()} ${VarietyDesc?.trim()} ${SizeID?.trim()}`
            }
        ])
    }

    const toggleSide = () => { //switch goods side
        setSide(!side)
    }

    const minusValue = () => {
        if (packs > 0) {
            setPacks(packs - 1)
        }
    }
    const calculatePrice = (e) => {
        const value = Number(e.target.value)
        if (MinPrice !== undefined && value < Math.min(MinPrice, OriginalPrice || SalePrice || Price)) {
            setPriceGood(value)
            handleNotifications(`המחיר נמוך מהמינימום (${Math.min(MinPrice, OriginalPrice || SalePrice || Price)})`, {type: "warning"})
        } else {
            setPriceGood(value)
        }
    }
    const weightCalc = useMemo(() => {
        let weight = 0
        const packTypeDef = checkPackType(packegeList, +packType)

        const tempPackWeight = AvailablePacks.filter(e => e.PackID === +packType)[0]?.PackWeight

        const packIcon = packTypeDef === '2' ? <PackageIcon /> : 
            packTypeDef === '1' ? <ScalesIcon /> :
            ProductCalculationMethod === 1 ? <PackageIcon /> : <ScalesIcon />
        if(OrderPacks !== undefined) {
            if(weightRef.current && orderedPacksRef.current){
                const weightperPack = weightRef.current / orderedPacksRef.current
                weight = Math.round(packs * weightperPack)
                
            } else {
                weight = +packs * (tempPackWeight || PackWeight)
                console.log(weight)
            }
        
        } else {
                // const weightPerPack = (weightRef.current / orderedPacksRef.current).toFixed(2)
              
                weight = +packs * (tempPackWeight || PackWeight)
              
        }
            
        return {weight, packIcon: packIcon, packTypeDef}
    }, [weightRef.current, orderedPacksRef.current, OrderPacks, packs,packType, ProductCalculationMethod])
   
    const availablePacksWithDefault = useAvailablePacksWithDefault(AvailablePacks, PackID, Pack_Name)

    useEffect(() => {
        weightRef.current = OrderWeight
        orderedPacksRef.current = OrderPacks
    }, [])


    const isMlaiHidden = !getMlai
    const isMhirHidden = !(getMhir || editMhirMlaiStatus)
    let setlectedPack = productNonOrder.filter(e => e.id === id)[0]?.PackID
    const finalPrice = priceGood < Math.min(MinPrice, OriginalPrice || SalePrice || Price) ? (OriginalPrice || SalePrice || Price) : priceGood

    // Sync local state to parent on every change instead of onBlur
    useEffect(() => {
        collectData()
    }, [packs, packType, priceGood, mlai, remark])

    const handlePriceBlur = () => {
        if (priceGood < Math.min(MinPrice, OriginalPrice || SalePrice || Price)) {
            setPriceGood(OriginalPrice || SalePrice || Price)
        }
    }
    const handleMlaiChange = (e) => {
        const value = Number(e.target.value)
        if (value < 0) {
            setMlai(0)
        } else {
            setMlai(value)
        }
    }
    const recommendCount =
        dateDiff === 0 && RecommendQty?.AvgCnt1 > 0 ? Math.round(RecommendQty.AvgCnt1) :
        dateDiff === 1 && RecommendQty?.AvgCnt2 > 0 ? Math.round(RecommendQty.AvgCnt2) :
        dateDiff === 2 && RecommendQty?.AvgCnt3 > 0 ? Math.round(RecommendQty.AvgCnt3) : null;

    // Weight/units recommendation (AvgWgt) — shown only for unit/kg pack types,
    // independent of recommendCount (may render even when the count badge is absent).
    const recommendWeight =
        !(weightCalc.packTypeDef === '1' || weightCalc.packTypeDef === '2') ? null :
        dateDiff === 0 && RecommendQty?.AvgWgt1 > 0 ? Math.round(RecommendQty.AvgWgt1) :
        dateDiff === 1 && RecommendQty?.AvgWgt2 > 0 ? Math.round(RecommendQty.AvgWgt2) :
        dateDiff === 2 && RecommendQty?.AvgWgt3 > 0 ? Math.round(RecommendQty.AvgWgt3) : null;

    const handleCardClick = () => {
        if(!isPriced)  {
            getGoodPrice(ProductID, VarietyID, SizeID, PackID, id, item);
        }
        setDataForDetailes({ data: Pallets, title: ChangeReason });
        showDetailes(isDisableGeneral, ChangeReason);
    };

    /* MoreButton + Panel close keep their own concern (toggle panel only). */
    const handleMoreClick = (e) => { e?.stopPropagation?.(); toggleSide(); };
    /* Media click bubbles so the card-level handler (price fetch + showDetailes) also fires. */
    const handleMediaClick = () => { toggleSide(); };
    const handlePlus = (e) => { e?.stopPropagation?.(); setPacks(packs + 1); };
    const handleMinus = (e) => { e?.stopPropagation?.(); minusValue(); };
    const handleStepperInput = (e) => { setPacks(+e.target.value); };

    const isAlertCount = (ChangeReason === 5) || (OrderPacks !== SupplyQty);

    return (
        <ProductCard onClick={handleCardClick} tabIndex={0} style={{ zIndex: 1 }}>
            <ProductCard.MoreButton onClick={handleMoreClick} />
            {recommendCount != null ? <ProductCard.HintBadge value={recommendCount} /> : null}

            <ProductCard.Media onClick={handleMediaClick}>
                <ProductImage id={GeneralProductID} />
            </ProductCard.Media>

            <ProductCard.TitleBlock
                title={`${ProductDesc} ${VarietyDesc} ${SizeID}`}
                hint={
                    <>
                        <ProductCard.QtyBadge value={weightCalc.weight} icon={weightCalc.packIcon} active={packs > 0} />
                        {recommendWeight != null ? <ProductCard.HintInlineBadge value={recommendWeight} /> : null}
                    </>
                }
            />

            <ProductCard.PackSelect
                defaultValue={setlectedPack || PackID || 0}
                disabled={disableSelectPacks}
                dir="rtl"
                onChange={(e) => setPackType(e.target.value)}
                onClick={(e) => e.stopPropagation()}
            >
                <option value={0}>ארגז/קרטון</option>
                {availablePacksWithDefault.map((p) => (
                    <option key={p.PackID} value={p.PackID}>{p.Pack_Name?.trim()}</option>
                ))}
            </ProductCard.PackSelect>

            {isDisableGeneral ? (
                <ProductCard.Stepper
                    mode="readonly"
                    readonlyContent={
                        <ReadonlyRow $alert={isAlertCount}>
                            <span>{SupplyQty}/{packs}</span>
                            {ChangeReason === 5 ? <ClickIcon /> : null}
                        </ReadonlyRow>
                    }
                />
            ) : (
                <ProductCard.Stepper
                    value={packs}
                    disabled={disabelSave}
                    accent={packs > 0}
                    onPlus={handlePlus}
                    onMinus={handleMinus}
                    onInputChange={handleStepperInput}
                />
            )}

            <ProductCard.Panel open={side} onClose={handleMoreClick}>
                <ProductCard.FieldGrid>
                    <ProductCard.Field
                        // label="מחיר"
                        type="number"
                        inputMode="decimal"
                        step="any"
                        readOnly={!editMhirMlaiStatus}
                        disabled={isDisableGeneral}
                        placeholder="מחיר"
                        value={priceGood || roundToTwo(SalePrice)}
                        onChange={calculatePrice}
                        onBlur={handlePriceBlur}
                        onClick={(e) => { e.stopPropagation(); selectOnFocus(e); }}
                        hidden={isMhirHidden}
                    />
                    <ProductCard.Field
                        // label="מלאי"
                        type="number"
                        inputMode="numeric"
                        placeholder="0"
                        value={roundToTwo(mlai)}
                        disabled={isDisableGeneral}
                        onChange={handleMlaiChange}
                        onClick={(e) => { e.stopPropagation(); selectOnFocus(e); }}
                        hidden={isMlaiHidden}
                    />
                </ProductCard.FieldGrid>
                <ProductCard.Textarea
                    // label="הערה למוצר"
                    placeholder="הוסיפו הערה…"
                    value={remark}
                    disabled={isDisableGeneral}
                    onChange={(e) => setRemark(e.target.value)}
                    maxLength={200}
                />
            </ProductCard.Panel>
        </ProductCard>
    );
}

const ReadonlyRow = styled.div`
    display: inline-flex;
    align-items: center;
    gap: 6px;
    color: ${({ $alert, theme }) => ($alert ? theme.colors.danger : theme.colors.ink)};
    font-family: ${({ theme }) => theme.fonts.mono};
    font-size: 13px;
    line-height: 1.1;
    svg { width: 12px; height: 12px; }
    span { display: inline-block; }
`;

